<template>
    <div id="payComplete">
        <h1>Thank you for your contribution!</h1>
        <router-link to="/" class="button-submit" id="payCompleteReturnHome">Return Home</router-link>
    </div>
</template>

<script>
    export default {
        name: "PayComplete"
    };
</script>

<style scoped lang="less">
    #payCompleteReturnHome{
        font-size: 1.2rem;
    }
</style>



// WEBPACK FOOTER //
// src/components/travel-calculator/PayComplete.vue